var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"einvoice-status-badge badge font-weight-bold",class:[`badge-${_vm.variant}`, _vm.sizeClass]},[(_vm.showIcon)?_c('i',{staticClass:"mr-1",class:_vm.iconClass}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }